export default __webpack_public_path__ + "static/media/bg-total-coins.2b45ae2a.svg";